// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensoryAnalystId } from './FoodSensoryAnalyst';
import { foodSensoryRoundQuestionId } from './FoodSensoryRoundQuestion';
import { foodSensorySessionSampleId } from './FoodSensorySessionSample';
import { z } from 'zod';
export const foodSensoryResponseRevisionId = (z.number());
export const foodSensoryResponseRevision = z.object({
    id: foodSensoryResponseRevisionId,
    analyst_id: foodSensoryAnalystId,
    question_id: foodSensoryRoundQuestionId,
    sample_id: foodSensorySessionSampleId.nullable(),
    value_text: z.string().nullable(),
    value_number: z.number().nullable(),
    value_json: z.unknown().nullable(),
    saved_at: z.date(),
});
export const foodSensoryResponseRevisionInitializer = z.object({
    id: foodSensoryResponseRevisionId.optional(),
    analyst_id: foodSensoryAnalystId,
    question_id: foodSensoryRoundQuestionId,
    sample_id: foodSensorySessionSampleId.optional().nullable(),
    value_text: z.string().optional().nullable(),
    value_number: z.number().optional().nullable(),
    value_json: z.unknown().optional().nullable(),
    saved_at: z.date().optional(),
});
export const foodSensoryResponseRevisionMutator = z.object({
    id: foodSensoryResponseRevisionId.optional(),
    analyst_id: foodSensoryAnalystId.optional(),
    question_id: foodSensoryRoundQuestionId.optional(),
    sample_id: foodSensorySessionSampleId.optional().nullable(),
    value_text: z.string().optional().nullable(),
    value_number: z.number().optional().nullable(),
    value_json: z.unknown().optional().nullable(),
    saved_at: z.date().optional(),
});
//# sourceMappingURL=FoodSensoryResponseRevision.js.map